import { useCallback } from "react";
import { SrId } from "@evergis/react";

import { useResetGeometryEditor } from "./useResetGeometryEditor";
import { useShowLayerOnMap } from "./useShowLayerOnMap";

export const useZoomToLayer = (layerName: string, srid: SrId): (() => void) => {
  const [showLayerOnMap] = useShowLayerOnMap(srid);
  const resetGeometryEditor = useResetGeometryEditor();

  return useCallback(() => {
    resetGeometryEditor();
    showLayerOnMap(layerName);
  }, [resetGeometryEditor, showLayerOnMap, layerName]);
};
